(() => {
  'use strict';

  if (window.TutorialComponentsInitialized) return;
  window.TutorialComponentsInitialized = true;

  const VIMEO_ID_PATTERN = /^\d+$/;

  class TutorialVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.trigger = this.querySelector('.tutorial-video__trigger');
      this.handlePlay = this.handlePlay.bind(this);
      this.trigger?.addEventListener('click', this.handlePlay);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.handlePlay);
    }

    handlePlay() {
      const videoId = this.dataset.videoId;
      const provider = this.dataset.provider;

      if (provider !== 'vimeo' || !VIMEO_ID_PATTERN.test(videoId || '')) {
        console.warn('[TutorialVideo] 无法加载无效的 Vimeo 视频。');
        return;
      }

      const iframe = document.createElement('iframe');
      const title = this.trigger?.getAttribute('aria-label')?.replace(/^Watch\s+/i, '') || 'Tutorial video';

      iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&color=000000&api=1&autopause=0&loop=0`;
      iframe.title = title;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;

      this.replaceChildren(iframe);
      this.classList.add('is-playing');
    }
  }

  class TutorialTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleClick);
        tab.addEventListener('keydown', this.handleKeydown);
      });

      const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      if (selectedTab) this.activateTab(selectedTab, false);
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.handleClick);
        tab.removeEventListener('keydown', this.handleKeydown);
      });
    }

    handleClick(event) {
      this.activateTab(event.currentTarget, false);
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], true);
    }

    activateTab(activeTab, moveFocus) {
      const panelId = activeTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        tab.classList.toggle('is-active', isActive);
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });

      if (moveFocus) activeTab.focus();
    }
  }

  class TutorialAccordion extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.handleToggle = this.handleToggle.bind(this);
      this.addEventListener('toggle', this.handleToggle, true);
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.handleToggle, true);
    }

    handleToggle(event) {
      const openedItem = event.target;
      if (!(openedItem instanceof HTMLDetailsElement) || !openedItem.open) return;

      this.querySelectorAll('details[open]').forEach((item) => {
        if (item !== openedItem) item.open = false;
      });
    }
  }

  const registerComponent = (name, componentClass) => {
    if (!customElements.get(name)) customElements.define(name, componentClass);
  };

  registerComponent('tutorial-video', TutorialVideo);
  registerComponent('tutorial-tabs', TutorialTabs);
  registerComponent('tutorial-accordion', TutorialAccordion);

  // Shopify 主题编辑器动态插入 section 后，主动升级其中的自定义元素。
  document.addEventListener('shopify:section:load', (event) => {
    customElements.upgrade(event.target);
  });
})();
